module.exports = __webpack_public_path__ + "media/images/shark/Chippy-8537a9d908bc208c2e37a01d654c05da.jpg";